import RatingInput from '@/components/app/formItem/RatingInput';
import { Row, Col, Form, Checkbox, Radio, Input } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

const requiredRule = {
  required: true,
  message: <Trans>VALIDATE_REQUIRED</Trans>,
};
type Props = {
  disabled: boolean;
};

export default function MealItem({ disabled }: Props) {
  const { t } = useTranslation();
  return (
    <>
      <Row gutter={6}>
        <Col md={5} xs={12}>
          <Form.Item label={t('facilityReviewRate')} name="comprehensiveRate" rules={[requiredRule]}>
            <RatingInput disabled={disabled} className="input-value-color" />
          </Form.Item>
        </Col>
        <Col md={5} xs={12}>
          <Form.Item label={t('facilityReview_FacilityMealRate')} name="facilityRate">
            <RatingInput disabled={disabled} className="input-value-color" />
          </Form.Item>
        </Col>
        <Col md={4} xs={12}>
          <Form.Item label={t('facilityReview_ContentMealRate')} name="contentsRate">
            <RatingInput disabled={disabled} className="input-value-color" />
          </Form.Item>
        </Col>
        <Col md={4} xs={12}>
          <Form.Item label={t('facilityReview_CustomerServiceRate')} name="customerServiceRate">
            <RatingInput disabled={disabled} className="input-value-color" />
          </Form.Item>
        </Col>
        <Col md={6} xs={24}>
          <Form.Item name="mealType" label="   ">
            <Radio.Group className="input-value-color" defaultValue={2} disabled={disabled}>
              <Radio value={1}>朝食</Radio>
              <Radio value={2}>昼食</Radio>
              <Radio value={3}>夕食</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      {window.innerWidth > 700 ? (
        <Row gutter={6}>
          <Col flex={1}>
            <Form.Item label={t('tourEvaluation_MealPlanedStartTime')} name="planedStartTime">
              <Input type="time" disabled={disabled} className="input-value-color w-100" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item label={t('tourEvaluation_MealActualStartTime')} name="actualStartTime">
              <Input type="time" disabled={disabled} className="input-value-color" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item label={t('tourEvaluation_MealPlanedEndTime')} name="planedEndTime">
              <Input type="time" disabled={disabled} className="input-value-color w-100" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item label={t('tourEvaluation_MealActualEndTime')} name="actualEndTime">
              <Input type="time" disabled={disabled} className="input-value-color w-100" />
            </Form.Item>
          </Col>

          <Col flex={1}>
            <Form.Item label={t('tourEvaluation_MealIdealStayTime')} name="idealStayTime">
              <Input type="time" disabled={disabled} className="input-value-color w-100" />
            </Form.Item>
          </Col>
        </Row>
      ) : (
        <Row gutter={6}>
          <Col md={6} xs={24}>
            <Form.Item label={t('tourEvaluation_MealPlanedStartTime')} name="planedStartTime">
              <Input type="time" disabled={disabled} className="input-value-color w-100" />
            </Form.Item>
          </Col>
          <Col md={6} xs={24}>
            <Form.Item label={t('tourEvaluation_MealActualStartTime')} name="actualStartTime">
              <Input type="time" disabled={disabled} className="input-value-color" />
            </Form.Item>
          </Col>
          <Col md={6} xs={24}>
            <Form.Item label={t('tourEvaluation_MealPlanedEndTime')} name="planedEndTime">
              <Input type="time" disabled={disabled} className="input-value-color w-100" />
            </Form.Item>
          </Col>
          <Col md={6} xs={24}>
            <Form.Item label={t('tourEvaluation_MealActualEndTime')} name="actualEndTime">
              <Input type="time" disabled={disabled} className="input-value-color w-100" />
            </Form.Item>
          </Col>

          <Col md={6} xs={24}>
            <Form.Item label={t('tourEvaluation_MealIdealStayTime')} name="idealStayTime">
              <Input type="time" disabled={disabled} className="input-value-color w-100" />
            </Form.Item>
          </Col>
        </Row>
      )}

      <Row gutter={6}>
        <Col md={24} xs={24}>
          <Form.Item label={t('tourEvaluation_MealCustomerReaction')} name="customerReaction">
            <TextArea autoSize={{ minRows: 3 }} className="input-value-color" disabled={disabled} />
          </Form.Item>
        </Col>
        <Col md={24} xs={24}>
          <Form.Item label=" 詳細(アレルギー対応やドリンクの個別払い対応について等を記載ください)" name="details">
            <TextArea autoSize={{ minRows: 3 }} className="input-value-color" disabled={disabled} />
          </Form.Item>
        </Col>
        <Col md={24} xs={24}>
          <Form.Item label={t('tourEvaluation_MealRecommendationInSameArea')} name="recommendationInSameArea">
            <TextArea autoSize={{ minRows: 3 }} className="input-value-color" disabled={disabled} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}
